<template>
  <div class="pay-result">
    <div class="text">支付成功</div>
    <van-button type="primary" @click="JumpToHome">返回商家</van-button>
  </div>
</template>

<script >
import { onMounted } from "vue";
export default {
  setup() {
    // 微信商家小票
    const wxInit = () => {
      //初始化小票
      var initData = {
        action: "onIframeReady",
        displayStyle: "SHOW_CUSTOM_PAGE",
      };
      var initPostData = JSON.stringify(initData);
      parent.postMessage(initPostData, "https://payapp.weixin.qq.com");
    };
    onMounted(() => {
      wxInit();
    });
    //注册点击事件(去首页)
    const JumpToHome = () => {
      let homePage = "https://thunder-ci-5-2-webapp.lcola.cn/station/staring_charging";
      var mchData = {
        action: "jumpOut",
        jumpOutUrl: homePage, //跳转的页面
      };
      var postData = JSON.stringify(mchData);
      parent.postMessage(postData, "https://payapp.weixin.qq.com");
    };
    return { JumpToHome };
  },
};
</script>

<style lang="scss" scoped>
.pay-result {
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 100px;
  .text {
    margin-bottom: 50px;
    font-weight: 600;
    font-size: 18px;
    color: green;
  }
}
</style>

